import { VoucherMessage, VoucherMessageLazada, VoucherMessageTiktok } from 'components/Dialogue';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { memo } from 'react';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';

export const VoucherMsg = memo((props: BaseMsgProps) => {
  const { msg, conversation } = props;
  const {
    raw: { voucherContent: { voucherId, voucherCode } = {} },
  } = msg;
  const { channel } = conversation;

  if (voucherId === undefined || voucherCode === undefined) {
    return null;
  }

  return (
    <MessageExtendComplex
      {...props}
      content={
        channel === 'LAZADA' ? (
          <VoucherMessageLazada voucherId={voucherId} voucherCode={voucherCode} />
        ) : isTiKTokUpperCase(channel) ? (
          <VoucherMessageTiktok voucherId={voucherId} voucherCode={voucherCode} />
        ) : (
          <VoucherMessage voucherId={voucherId} voucherCode={voucherCode} />
        )
      }
    />
  );
});
